module.exports = __webpack_public_path__ + "static/img/banner_zengo@2x.06e31df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/go/banner_zengo@2x.jpg
// module id = 94
// module chunks = 0